<!--
    `aria-label` na linha inteira e `aria-hidden` na seta: o glifo é decorativo para quem ouve, e a
    frase composta é o que faz sentido em voz alta. Mesmo tratamento da timeline do quadro.
    A seta é texto (`&rarr;`), não ícone de fonte: ícone entraria na escala do `pi` e desalinharia
    com selos de 11px.
-->
<span class="vigencia" [attr.aria-label]="descricao()">
    <span class="vigencia-chip">{{ solicitacao() || '-' }}</span>
    <span class="vigencia-seta" aria-hidden="true">&rarr;</span>
    <span [class]="'vigencia-chip vigencia-chip--' + severidade()">{{ validade() || '-' }}</span>
</span>
